import React, { useState, useEffect, Fragment } from "react";
import axios from "axios";
import "./style.css";
import { makeStyles, createStyles } from "@material-ui/core/styles";

import ResortList from "./ResortList";
import Grid from "@material-ui/core/Grid";
import { setUserGroup } from './action';

import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ReactComponent as Mvc } from "../../images/mvc.svg";
import MaterialIcon from "react-google-material-icons";
import { getResortData, getMarshaData, getTableData } from "./action";
import { connect } from "react-redux";
import AddResort from "./AddResort";
import EditResort from "./EditResort";
const drawerWidth = 280;

const useStyles = makeStyles((theme) =>
  createStyles({
    cancelbtn: {
      color: "#0096D6",
      backgroundColor: "#fff",
      "&:hover": {
        backgroundColor: "#fff",
      },
      borderRadius: "20px",
      width: "100px",
      BorderColor: "#0096D6",
      marginLeft: "10px",
    },
    searchbtn: {
      color: "#fff",
      backgroundColor: "#0096D6",
      "&:hover": {
        backgroundColor: "#0096D6",
      },
      borderRadius: "20px",
      width: "100px",
      BorderColor: "#fff",
    },
    listContent: {
      alignContent: "center",

      flex: "none",
    },
    EditText: {
      color: "#0096D6",
      fontSize: "bold",
      marginTop: "1",
    },
    dialog1: {
      maxWidth: "100%",
    },
    table: {
      minWidth: 650,
    },
    labelText: {
      fontWeight: "bold",
    },
    tableContainer: {
      marginTop: 50,
    },
    root: {
      display: "flex",
    },
    appBar: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      background: "transparent",
      color: "black",
      boxShadow: "none",
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidth,
      backgroundColor: "#0096D6",
    },
    textStyle: {
      color: "#ffffff",
      fontSize: "20px",
    },
    iconStyle: {
      color: "#ffffff",
      minWidth: "30px",
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.default,
      padding: theme.spacing(3),
    },
  })
);
const logout = makeStyles((theme) => ({
  root: {
    position: "absolute",
    bottom: "0",
    height: "150px",
    fontSize: "12px",
    color: "white",
    paddingLeft: "3rem",
  },
}));

const App = (props) => {
  // Data

  const initialFormState = {
    priorityId: "",
    sunPropertyID: "",
    sunRoomType: "",
    marshaCode: "",
    marshaRoomPool: "",
    marshaMiniHotelCode: "",
    marshaMiniHotelName: "",
    miniHotelPrioirty:"",
    marshaRateProgram: "",
    reservationType: "",
    activeFlag: false,
    notes: "",
  };
  const baseURL = process.env.REACT_APP_VSNMSAS_EXP_API_BASE_URL_VAL
  ? process.env.REACT_APP_VSNMSAS_EXP_API_BASE_URL_VAL
  :"" ;
  const URL = process.env.REACT_APP_VSNMSAS_EXP_API_USER_INFO_VAL
    ? process.env.REACT_APP_VSNMSAS_EXP_API_USER_INFO_VAL
    : "";
  // Setting state
  // const baseURL = "https://at01.api.ad.mvwcorp.com/api/exp/vsn-msas-priorities/v1";
  const [person, setPerson] = useState('');
  const [profile, setProfile] = useState('');
  const [picture, setPicture] = useState('');

  const [resData, setResData] = React.useState({ errors: null });

  const [addData, setAddData] = React.useState("");
  const [editData, setEditData] = React.useState("");
  const [open, setOpen] = useState(false);
  const [opens, setOpens] = useState(false);
  const [resort, setResort] = useState("");
  const [code, setCode] = useState("");
  const [active, setActive] = useState("");
  const [users, setUsers] = useState("");

  const [currentUser, setCurrentUser] = useState(initialFormState);
  const [editing, setEditing] = useState(false);
  let count = 0;
	const onLoad = () => {
		const token = localStorage.getItem('pfJwt');

		axios
			.get(URL, { headers: { Authorization: `Bearer ${token}` } })
			.then((res) => {
				const name = `${res.data.given_name}`;
				const fullName = `${res.data.given_name} ${res.data.family_name}`;
				const userPic = `${res.data.picture}`;
				const admins = [process.env.REACT_APP_VSNMSAS_EXP_API_GROUPS_VAL];
				for (var i = 0, max = admins.length; i < max; i++) {
					for (var j = 0, maxi = res.data.groups.length; j < maxi; j++) {
						let c =
							res.data.groups[j].search(admins[i]) !== -1
								? (count = count + 1)
								: null;
					}
				}
				if (count > 0) {
					props.setUserGroup('admin');
				} else {
					props.setUserGroup('others');
				}
				if (res.data !== null && res.data.name !== null) {
					setPerson(name);
					setProfile(fullName);
					setPicture(userPic);
				} else {
					setPerson('No given_name available');
					setProfile('No fullName available');
					setPicture('No picture available');
				}
			})
			.catch((error) => {
				setPerson(error);
			});
	};
	useEffect(() => {
		onLoad();
	}, []);
  
  useEffect(() => {
    let resortListURL = baseURL+`/sun`;
    props.getResortData(resortListURL);
  }, []);
  useEffect(() => {
    setResort("");
  }, []);
  useEffect(() => {
    let codeListURL = baseURL+`/marsha`;
    props.getMarshaData(codeListURL);
  }, []);
  useEffect(() => {
    setCode("");
  }, []);
  useEffect(() => {
    reset();
  }, []);
  useEffect(() => {
    props.getTableData();
  }, []);
  useEffect(() => {
    setCode("");
  }, []);
  const reset = () => {
    setResort("");
    setCode("");
    setActive("");
    props.getTableData();
  };
  // CRUD operations
  const Logout = () => {
    localStorage.clear();
  };
  const handleClose = () => {
    setOpens(false);
  };

  const handleSearch = () => {
    //console
    if (resort !== "" && code !== "") {
    } else if (resort !== "") {
      let tableListURL = baseURL+`/sun/${resort}`;

      props.getTableData(tableListURL);
    } else if (code !== "") {
      let tableListURL =baseURL+ `/marsha/${code}`;

      props.getTableData(tableListURL);
    } else {
      props.getTableData();
    }
  };

  const addResort = (user) => {
    let URL =baseURL+ `/`;

    const body = {
      sunPropertyID: user.sunPropertyID,
      sunRoomType: user.sunRoomType,
      marshaCode: user.marshaCode,
      marshaRoomPool: user.marshaRoomPool,
      marshaMiniHotelCode: user.marshaMiniHotelCode,
      marshaMiniHotelName: user.marshaMiniHotelName,
      reservationType: user.reservationType,
      marshaRateProgram: user.marshaRateProgram,
      activeFlag: user.activeFlag,
      notes: user.notes,
      miniHotelPrioirty: user.miniHotelPrioirty,
    };

    axios
      .post(URL, body)
      .then((res) => {
        setAddData(res.data);

        setOpens(false);

        if (resort !== "") {
          let tableListURL = baseURL+`/sun/${resort}`;

          props.getTableData(tableListURL);
        } else if (code !== "") {
          let tableListURL =baseURL+ `/marsha/${code}`;

          props.getTableData(tableListURL);
        }
      })
      .catch((error) => {
        setAddData(error);
        setOpens(false);

        alert(error, "record already exist");
      });
  };
  const addRow = () => {
    setOpens(true);
  };

  const updateResort = (updatedResort) => {
    let URL =baseURL+ `/${updatedResort.priorityId}`;
    const body = {
      sunPropertyID: updatedResort.sunPropertyID,
      sunRoomType: updatedResort.sunRoomType,
      marshaCode: updatedResort.marshaCode,
      marshaRoomPool: updatedResort.marshaRoomPool,
      marshaMiniHotelCode: updatedResort.marshaMiniHotelCode,
      marshaMiniHotelName: updatedResort.marshaMiniHotelName,
      reservationType: updatedResort.reservationType,
      marshaRateProgram: updatedResort.marshaRateProgram,
      activeFlag: updatedResort.activeFlag,
      notes: updatedResort.notes,
      miniHotelPrioirty: updatedResort.miniHotelPrioirty,
    };
    axios
      .put(URL, body)
      .then((res) => {
        setEditData(res.data);
        document.getElementById("edit_close_btn").click();
        // handleSearch()
        if (resort !== "") {
          let tableListURL =baseURL+ `/sun/${resort}`;

          props.getTableData(tableListURL);
        } else if (code !== "") {
          let tableListURL =baseURL+ `/marsha/${code}`;

          props.getTableData(tableListURL);
        }
      })
      .catch((error) => {
        setEditData(error);
        alert(error);
      });
  };

  const editRow = (user) => {
    setEditing(true);
    setOpen(true);

    setCurrentUser({
      priorityId: user.priorityId,
      sunPropertyID: user.sunPropertyID,
      sunRoomType: user.sunRoomType,
      marshaCode: user.marshaCode,
      marshaRoomPool: user.marshaRoomPool,
      marshaMiniHotelCode: user.marshaMiniHotelCode,
      reservationType: user.reservationType,
      marshaMiniHotelName: user.marshaMiniHotelName,
      miniHotelPrioirty: user.miniHotelPrioirty,
      marshaRateProgram: user.marshaRateProgram,
      notes: user.notes,
      activeFlag: user.activeFlag,
    });
  };

  const updateUserstatus = (Currentuser) => {
    setOpen(true);

    Currentuser.state = !Currentuser.state;

    setUsers(
      users.map((user) => (user.id === Currentuser.id ? Currentuser : user))
    );
  };

  const classes = useStyles();
  const logot = logout();

  return (
    <>
    {props.userGroup === 'admin' ? (

  
      <div className={classes.root}>
        <CssBaseline />

        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
          anchor="left"
        >
          <span className="logoAlign">
            <Mvc />
          </span>
          <div className={classes.toolbar} />
          <div className='linkSection'>
					<div className='title'>Welcome {person},</div>
				</div>
        {/* <div
					className={
						props.userGroup === 'admin' ? 'detailsList' : 'inqDetailsList'
					}
				>
				
				</div> */}
          <div className={logot.root}>
            <Link className="logLink" to="/logout" onClick={Logout}>
              <MaterialIcon icon="logout" size={18} />
              <span style={{ color: "white" }}>Log out</span>
            </Link>
          </div>
        </Drawer>

        <main className={classes.content}>
          <div
            className={classes.paper1}
            style={{ border: "1px ", borderRadius: "9px" }}
          >
            {editing ? (
              <Fragment>
                <Dialog
                  fullWidth={true}
                  maxWidth={"lg"}
                  className={classes.dialog1}
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <EditResort
                    open={open}
                    editing={editing}
                    setEditing={setEditing}
                    currentUser={currentUser}
                    updateResort={updateResort}
                  />
                </Dialog>
              </Fragment>
            ) : (
              <Fragment>
                <Dialog
                  fullWidth={true}
                  maxWidth={"lg"}
                  className={classes.dialog1}
                  open={opens}
                  handleClose={handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <AddResort
                    setopen={setOpens}
                    handleClose={handleClose}
                    addResort={addResort}
                  />
                </Dialog>
              </Fragment>
            )}
          </div>

          <div className={classes.toolbar} />

          <Grid container spacing={3} style={{ marginTop: "-5%" }}>
            <Grid item xs={12} md={4}>
              <span className="resort-maintenance">Sun Property</span>
              <span>
                {" "}
                <input
                  id="maintenanceResort"
                  value={resort}
                  type="text"
                  name="resort"
                  list="maintenanceresortname"
                  placeholder=" Enter Sun Property"
                  onChange={(event) => {
                    setResort(event.target.value);
                  }}
                />
                <datalist id="maintenanceresortname">
                  {props.maintenanceResortList.length !== 0 &&
                  props.maintenanceResortList
                    ? props.maintenanceResortList.map((resort) => (
                        <option value={resort.name}>{resort.sunCode}</option>
                      ))
                    : null}
                </datalist>
              </span>
            </Grid>
            <Grid item xs={12} md={4}>
              <span className="resort-maintenance">Marsha Code</span>
              <span>
                {" "}
                <input
                  id="maintenanceResort"
                  value={code}
                  type="text"
                  name="code"
                  list="codename"
                  placeholder=" Enter Marsha Code"
                  onChange={(event) => {
                    setCode(event.target.value);
                  }}
                />
                <datalist id="codename">
                  {props.marshaCodeList.length !== 0 && props.marshaCodeList
                    ? props.marshaCodeList.map((code) => (
                        <option value={code.name}>{code.marshaCode}</option>
                      ))
                    : null}
                </datalist>
              </span>
            </Grid>
            {/* <Grid item xs={12} md={4}>
              <span className="resort-maintenance">Active only</span>

              <input
                id="maintenanceResort"
                type="text"
                name="active"
                list="active"
                placeholder="select active "
                onChange={(event) => {
                  setActive(event.target.value);
                }}
              />
              <datalist id="active">
                <option value="Yes"></option>
                <option value="NO"></option>
              </datalist>
            </Grid> */}
            <Grid item xs={12} md={6}>
              <Button
                variant="contained"
                className={classes.searchbtn}
                onClick={handleSearch}
              >
                search
              </Button>

              <Button
                variant="contained"
                className={classes.cancelbtn}
                onClick={() => reset()}
              >
                reset
              </Button>
            </Grid>

            <Grid item xs={12} md={6}>
              <Button
                onClick={addRow}
                style={{ float: "right", marginRight: "15%" }}
                variant="contained"
                className={classes.searchbtn}
              >
                Add
              </Button>
            </Grid>
          </Grid>
          <>
            <ResortList
              open={open}
              users={users}
              editRow={editRow}
              updateUserstatus={updateUserstatus}
            />
          </>
        </main>
      </div>
     
    
    ) : (<h1>Have no Access</h1>)}
    </>
  );
};
//code
const mapStateToProps = (state) => {
  return {
    maintenanceResortList: state.maintenanceResortList.resortList,
    marshaCodeList: state.marshaCodeList.codeList,
    tabledataList: state.tabledataList.tableList,
    userGroup: state.userGroup.userGroup,
  };
};
export default connect(mapStateToProps, {
  getResortData,
  getMarshaData,
  getTableData,
  setUserGroup,
})(App);
